import PropTypes from 'prop-types';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './recipient.m.css';

function RecipientDetails({
	recipient,
	showRemove,
	handleClick,
	getNextColor,
	getTextNextColor
}) {
	const theme = useTheme();
	const isMobile = useMediaQuery('(max-width:768px)');

	const Recipient = {
		backgroundColor: getNextColor(),
		color: getTextNextColor(),
		border: '1px solid',
		height: '40px',
		width: '40px',
		display: 'flex',
		justifyContent: 'center',
		borderRadius: '50px',
		alignItems: 'center'
	};

	const handleResClick = (e) => {
		e.stopPropagation();
		handleClick(recipient);
	};

	return (
		<Box
			display={'flex'}
			alignItems={'center'}
			justifyContent={'space-between'}
			width={'100%'}
		>
			<Box display={'flex'} alignItems={'center'} gap={1.5}>
				<div style={Recipient}>
					{recipient.userData.firstName[0].toUpperCase()
						+ recipient.userData.lastName[0].toUpperCase()}
				</div>
				<div>
					<div
						className={isMobile ? 'medium7' : 'medium4'}
						style={{ marginBottom: theme.spacing(0.5) }}
					>
						{recipient.userData.firstName} {recipient.userData.lastName}
					</div>
					<div
						className={isMobile ? 'medium8' : 'medium6'}
						style={{
							color: '#8E8E8E'
						}}
					>
						{recipient.userData.email}
					</div>
				</div>
			</Box>
			<Box className='pointer-css ck-iconcenteralign' onClick={handleResClick}>
				{showRemove ? (
					<HighlightOffIcon
						sx={{ fontSize: isMobile ? 22 : 28, color: '#8E8E8E' }}
					/>
				) : (
					<ChevronRightIcon
						sx={{ fontSize: isMobile ? 22 : 28, color: '#21241E' }}
					/>
				)}
			</Box>
		</Box>
	);
}

export default RecipientDetails;

RecipientDetails.propTypes = {
	recipient: PropTypes.any,
	showRemove: PropTypes.any,
	handleClick: PropTypes.any,
	getNextColor: PropTypes.any,
	getTextNextColor: PropTypes.any
};
